import * as React from "react";

function SvgMoreAction(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 6 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3a3 3 0 11-6 0 3 3 0 016 0zm0 9a3 3 0 11-6 0 3 3 0 016 0zm0 9a3 3 0 11-6 0 3 3 0 016 0z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgMoreAction;
